<template>
  <div>
    <template v-for="item in dialogs">
      <!-- Use scrollable instead fullscreen, because fullscreen does not work, problem with scrolling on parent element. Scrollable gives possibility change style for our v-dialog -->
      <v-dialog v-model="item.show" :contentClass="item.fullscreen && 'v-modal-factory-fullscreen'" max-width="600px" persistent>
        <component
          :is="item.comp"
          v-on:close="close(item.id)"
        ></component>
      </v-dialog>
    </template>
  </div>
</template>

<script>
  class Dialog {
    constructor (comp, fullscreen) {
      this.id = new Date()
      this.show = true
      this.comp = comp
      this.fullscreen = fullscreen
    }
  }

  export default {
    name: 'modal-factory',
    data: () => {
      return {
        dialogs: []
      }
    },
    methods: {
      isModal () {
        return this.dialogs.length > 0
      },
      close (id) {
        this.dialogs = this.dialogs.filter(item => item.id !== id)
      },
      open (comp) {
        var data = comp.data instanceof Function ? comp.data() : comp.data
        var fullscreen = data && data.fullscreen != null ? data.fullscreen : this.$vuetify.breakpoint.xsOnly
        console.log('open', fullscreen, data)
        let item = new Dialog(comp, fullscreen)
        this.dialogs.push(item)
      }
    }
  }
</script>
<style>
  .v-dialog.v-modal-factory-fullscreen {
    margin: 0;
    max-height: 100%;
  }
</style>



// WEBPACK FOOTER //
// ModalFactory.vue?45805ed4